import { computed } from 'mobx';
import {
    CollateralApiFindAllCollateralsRequest,
    CollateralDto,
} from 'src/generated-api-client';
import {
    bpmsResourcesManagerApi,
    collateralsApi,
} from 'src/services/apiServices';
import { ListFilter } from 'src/utils/FormHelper';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { FilterCriteria } from 'src/utils/mobx/FilterCriteria';
import { Pager } from 'src/utils/mobx/Pager';
import { Sorter } from 'src/utils/mobx/Sorter';
import { RequestHelper } from 'src/utils/RequestHelper';

export type CollateralsFilter =
    ListFilter<CollateralApiFindAllCollateralsRequest>;

export class CollateralsStoreClass extends BasicStore<
    CollateralDto,
    CollateralsFilter,
    unknown,
    unknown,
    CollateralDto
> {
    itemPathKey = 'collateralId';
    itemDetailsFormKey = 'embedded:deployment:forms/bo/bo-62-collateral.json';

    pager = new Pager();
    sorter = new Sorter();
    filterCriteria = new FilterCriteria<CollateralsFilter>();

    api: BasicStoreApi<CollateralDto, unknown, unknown, CollateralDto> = {
        loadList: async (...args: any[]) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const response = await RequestHelper.unwrapFromAxiosPromise(
                collateralsApi.findAllCollaterals(
                    {
                        ...this.pager,
                        ...this.sorter,
                        ...this.filterCriteria.filter,
                    },
                    options,
                ),
            );

            this.pager.setTotal(response.totalElements || 0);

            return response.content || [];
        },
        loadItem: (id: number, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                collateralsApi.getCollateral({ id }, options),
            );
        },
        loadItemForm: (formKey: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm({ formKey }, options),
            );
        },
    };

    @computed get hasFilter() {
        return (
            Boolean(this.filterCriteria.filter.filterSearch) ||
            Boolean(this.filterCriteria.filter.filterCollateralTypes)
        );
    }
}

export const CollateralsStore = new CollateralsStoreClass();
